import { makeStyles } from '@material-ui/styles'

export const useClasses = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    justifyContent: 'center',
    padding: theme.spacing(1.5, 1.5, 5),
    borderBottom: '1px solid #d1d1d1',
    [theme.breakpoints.down(theme.breakpoints.values.xs)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  image: {
    aspectRatio: 1,
    maxHeight: theme.typography.pxToRem(120),
  },
  noImage: {
    minWidth: 120,
    minHeight: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius,
  },
  imageIcon: {
    fontSize: `${theme.typography.pxToRem(24)} !important`,
  },
  details: {},
  detailsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  detailsHeaderTop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  detailsHeader: {
    display: 'flex',
    gap: theme.spacing(1),
    flexDirection: 'column',
  },
  title: {
    fontWeight: 600,
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.campaign.titleColor,
  },
  status: {
    fontWeight: 700,
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.campaign.statusColor,
  },
  validity: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.campaign.validityColor,
  },
  description: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.campaign.textColor,
  },
  adherence: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 'normal',
    width: 'fit-content',
    height: 'fit-content',
    gap: theme.spacing(1),
    padding: theme.spacing(0, 1),
    borderRadius: theme.spacing(1.5),
    color: theme.palette.campaign.adherenceColor,
    backgroundColor: theme.palette.campaign.AdherenceBackground,
    '& p': {
      textWrap: 'nowrap',
      fontSize: theme.typography.pxToRem(13),
      color: theme.palette.campaign.adherenceColor,
    },
  },
  adherenceDate: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    width: 'fit-content',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    color: theme.palette.campaign.adherenceDateColor,
    '& p': {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.campaign.adherenceDateColor,
    },
  },
}))
